import { defineRoute } from '@kestrel/router';

import { ROUTE_PATHS } from './route-paths.js';

export const routes = [
    defineRoute({
        path: ROUTE_PATHS.HEALTH,
        methods: () => import('./views/health/+health.server.js'),
    }),
    defineRoute({
        path: ROUTE_PATHS.METRICS,
        methods: () => import('./views/metrics/+metrics.server.js'),
    }),
    defineRoute({
        path: ROUTE_PATHS.DESCRIPTION,
        template: () => import('./views/description/template.html?raw'),
        component: () => import('./views/description/+page.svelte'),
        server: () => import('./views/description/+page.server.js'),
    }),
];
